export default "__VITE_ASSET__Dp3PCq3m__"